import React from 'react';
import { translate } from 'react-i18next';

import {Button, Form, Input, Grid, Header, Message, Label, Segment, Modal} from 'semantic-ui-react';

import styleDef from './style.js';
var style = {
    ...styleDef,
    form: {
        height: '100%',
        backgroundColor: 'white',
    },
    content: {
        textAlign: 'center',
    }
};

const ForgotPassword = ({t,
                         valid, 
                         email, 
                         emailError, 
                         onEmailChange, 
                         onResetRequest, 
                         onClose, 
                         message, 
                         error}) => (
        <Modal closeIcon open size="mini" onClose={onClose}>
        <Modal.Header>{t('Reset your password')}</Modal.Header>
        <Modal.Content style={style.content}>
            <Form style={style.form} noValidate onSubmit={onResetRequest}>
                {error.length==0 && message.length==0 &&
                    <div>
                    <div style={style.inputLabel}>{t('Email Address')}</div>
                    <Form.Field style={style.field}>        
                        <input 
                            style={{...style.input, 
                                    ...(emailError.length ? style.inputError : {})}}
                            type="text"
                            name="userEmail"
                            value={email}
                            onChange={onEmailChange}
                            required
                        />
                        {emailError.length > 0 &&
                            <Label basic color="red" pointing>{emailError}</Label>
                        }
                    </Form.Field>        
                    </div>
                }
                {error.length == 0 && message.length > 0 &&
                    <Message>{message}</Message>
                }
                {error.length > 0 &&
                    <Message negative>{error}</Message>
                }
                <br />
                {Boolean(message.length==0&&error.length==0) &&
                    <Button style={valid ? style.tealButton : style.greyButton} type="submit">{t('Reset')}</Button>
                }
                {!Boolean(message.length==0&&error.length==0) &&
                    <Button style={style.tealButton} type="button" onClick={onClose}>{t('OK')}</Button>
                }
            </Form>
        </Modal.Content>
      </Modal>
  );

export default translate('authentication')(ForgotPassword);



// WEBPACK FOOTER //
// ./src/modules/authentication/ForgotPassword.js